import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { InfoCircle } from 'tabler-icons-react';
import './CustomNode.css';

function CustomNode({id, data}:any) {
    if(id === 'null'){
      id = 'No table selected';
    }
    if(data === 'null'){
      data = 'No data available';
    }

  return (
    <>
      
      <div className="custom-node__body nowheel">
      <Handle
        type="source"
        position={Position.Bottom}
        id="a"
      />
     
      <div style={{textAlign: 'center'}}>
      <InfoCircle size={30} strokeWidth={2} color={"black"} />
      <h2>{id}</h2>
        <p style={{fontWeight: 10}}>Table name/ Alias</p>
      </div>
        
        
        <Handle
        type="target"
        position={Position.Top}
        id="b"
      />
      </div>
    </>
  );
}

export default memo(CustomNode);
